export default __webpack_public_path__ + "static/media/Salesforce.19800f6c.png";